{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Vlastné atribúty",
    "HEADER_BTN_TXT": "Pridať vlastný atribút",
    "LOADING": "Načítavajú sa vlastné atribúty",
    "DESCRIPTION": "Vlastný atribút sleduje dodatočné informácie o vašich kontaktoch alebo konverzáciách — napríklad plán predplatného alebo dátum ich prvého nákupu. Môžete pridať rôzne typy vlastných atribútov, ako text, zoznamy alebo čísla, pre zachytenie konkrétnych informácií, ktoré potrebujete.",
    "LEARN_MORE": "Zistiť viac o vlastných atribútoch",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Text",
      "NUMBER": "Číslo",
      "LINK": "Odkaz",
      "DATE": "Dátum",
      "LIST": "Zoznam",
      "CHECKBOX": "Zaškrtávacie pole",
      "TEXT_AREA": "Viacriadkový text"
    },
    "ADD": {
      "TITLE": "Pridať vlastný atribút",
      "SUBMIT": "Vytvoriť",
      "CANCEL_BUTTON_TEXT": "Zrušiť",
      "FORM": {
        "NAME": {
          "LABEL": "Zobrazovaný názov",
          "PLACEHOLDER": "Zadajte zobrazovaný názov vlastného atribútu",
          "ERROR": "Názov je povinný"
        },
        "DESC": {
          "LABEL": "Popis",
          "PLACEHOLDER": "Zadajte popis vlastného atribútu",
          "ERROR": "Popis je povinný"
        },
        "MODEL": {
          "LABEL": "Platí pre",
          "PLACEHOLDER": "Vyberte prosím jeden",
          "ERROR": "Model je povinný"
        },
        "TYPE": {
          "LABEL": "Typ",
          "PLACEHOLDER": "Vyberte prosím typ",
          "ERROR": "Typ je povinný",
          "LIST": {
            "LABEL": "Hodnoty zoznamu",
            "PLACEHOLDER": "Zadajte hodnotu a stlačte enter",
            "ERROR": "Musí mať aspoň jednu hodnotu"
          }
        },
        "KEY": {
          "LABEL": "Kľúč",
          "PLACEHOLDER": "Zadajte kľúč vlastného atribútu",
          "ERROR": "Kľúč je povinný",
          "IN_VALID": "Neplatný kľúč"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex vzor",
          "PLACEHOLDER": "Zadajte regex vzor vlastného atribútu. (Voliteľné)"
        },
        "REGEX_CUE": {
          "LABEL": "Nápoveda regex",
          "PLACEHOLDER": "Zadajte nápovedu k regex vzoru. (Voliteľné)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Povoliť overovanie regex"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Vlastný atribút bol úspešne pridaný!",
        "ERROR_MESSAGE": "Nepodarilo sa vytvoriť vlastný atribút. Skúste to prosím neskôr."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Vymazať",
      "API": {
        "SUCCESS_MESSAGE": "Vlastný atribút bol úspešne odstránený.",
        "ERROR_MESSAGE": "Nepodarilo sa odstrániť vlastný atribút. Skúste znova."
      },
      "CONFIRM": {
        "TITLE": "Určite chcete vymazať - {attributeName}",
        "PLACE_HOLDER": "Na potvrdenie zadajte {attributeName}",
        "MESSAGE": "Odstránenie odstráni vlastný atribút",
        "YES": "Vymazať ",
        "NO": "Zrušiť"
      }
    },
    "EDIT": {
      "TITLE": "Upraviť vlastný atribút",
      "UPDATE_BUTTON_TEXT": "Aktualizovať",
      "TYPE": {
        "LIST": {
          "LABEL": "Hodnoty zoznamu",
          "PLACEHOLDER": "Zadajte hodnoty a stlačte enter"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Vlastný atribút bol úspešne aktualizovaný",
        "ERROR_MESSAGE": "Pri aktualizácii vlastného atribútu nastala chyba, skúste to prosím znova"
      }
    },
    "TABS": {
      "HEADER": "Vlastné atribúty",
      "CONVERSATION": "Konverzácia",
      "CONTACT": "Kontakt"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Meno",
        "DESCRIPTION": "Popis",
        "TYPE": "Typ",
        "KEY": "Kľúč"
      },
      "BUTTONS": {
        "EDIT": "Upraviť",
        "DELETE": "Vymazať"
      },
      "EMPTY_RESULT": {
        "404": "Nie sú vytvorené žiadne vlastné atribúty",
        "NOT_FOUND": "Nie sú nakonfigurované žiadne vlastné atribúty"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex vzor",
        "PLACEHOLDER": "Zadajte regex vzor vlastného atribútu. (Voliteľné)"
      },
      "REGEX_CUE": {
        "LABEL": "Nápoveda regex",
        "PLACEHOLDER": "Zadajte nápovedu k regex vzoru. (Voliteľné)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Povoliť overovanie regex"
      }
    }
  }
}
